export const badgesConfig = [
  {
    unlock_level: 1,
    image_path: 'badge-1.png',
    name: 'Hiker',
    title: 'Started your journey',
  },
  {
    unlock_level: 2,
    image_path: 'badge-2.png',
    name: 'Yogi',
    title: 'Visited the Healing Lake',
  },
  {
    unlock_level: 3,
    image_path: 'badge-3.png',
    name: 'Fine Diner',
    title: 'Visited the Middle of Nowhere Diner',
  },
  {
    unlock_level: 4,
    image_path: 'badge-4.png',
    name: 'Camper',
    title: 'Visited the Camping Site',
  },
  {
    unlock_level: 5,
    image_path: 'badge-5.png',
    name: 'Space Explorer',
    title: 'Visited the Observatory (Are we alone in the universe?)',
  },
  {
    unlock_level: 6,
    image_path: 'badge-6.png',
    name: 'Winner',
    title: 'You did it, you have reached the top of the mountain!',
  },
];
